import { API_BASE_URL } from "../config/apiConfig";

const fetchAPI = async (endpoint, method = "GET", body = null, token = null) => {
    const headers = {
        "Content-Type": "application/json",
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const options = {
        method,
        headers,
    };

    if (body) {
        options.body = JSON.stringify(body);
    }

    const response = await fetch(`${API_BASE_URL}/api/parent-webinar/${endpoint}`, options);
    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.message || "Request failed");
    }

    return data;
};

// Get all parent webinar registrations
export const getParentWebinarRegistrations = (token) => fetchAPI("", "GET", null, token);

// Email a chosen set of parent registrants
export const sendParentWebinarMail = (data, token) => fetchAPI("send-mail", "POST", data, token);
